// Schlüssel je Einheit aus den Übergabeprotokollen (uebergabeprotokolle.schluessel).
// Ein eigenes Schlüsselregister gibt es nicht (Fehlende Daten); maßgeblich ist das letzte
// abgeschlossene Ein- oder Auszugsprotokoll der Einheit.

export interface UebergabeRoh {
  id: string;
  art: string;
  status: string;
  einheit_id: string | null;
  mieter_id: string | null;
  durchgefuehrt_am: string;
  schluessel: unknown;
}

export interface SchluesselPosten { bezeichnung: string; anzahl: number }

export interface SchluesselStand {
  einheitId: string;
  protokollId: string;
  art: 'einzug' | 'auszug';
  datum: string;
  mieterId: string | null;
  posten: SchluesselPosten[];
  summe: number;
}

/** Robust: nur Zeilen mit Bezeichnung, Anzahl ≥ 0 (Text wird gelesen). */
export function leseSchluessel(roh: unknown): SchluesselPosten[] {
  if (!Array.isArray(roh)) return [];
  return roh.flatMap(z => {
    if (typeof z !== 'object' || z === null) return [];
    const r = z as Record<string, unknown>;
    const bezeichnung = String(r.bezeichnung ?? '').trim();
    const anzahl = Number(r.anzahl);
    return bezeichnung && Number.isFinite(anzahl) && anzahl >= 0 ? [{ bezeichnung, anzahl }] : [];
  });
}

export function schluesselJeEinheit(protokolle: readonly UebergabeRoh[]): Map<string, SchluesselStand> {
  const m = new Map<string, SchluesselStand>();
  const sortiert = protokolle
    .filter(p => p.einheit_id && p.status === 'abgeschlossen' && (p.art === 'einzug' || p.art === 'auszug'))
    .sort((a, b) => a.durchgefuehrt_am.localeCompare(b.durchgefuehrt_am));
  for (const p of sortiert) {
    const posten = leseSchluessel(p.schluessel);
    m.set(p.einheit_id as string, {
      einheitId: p.einheit_id as string, protokollId: p.id, art: p.art as 'einzug' | 'auszug', datum: p.durchgefuehrt_am,
      mieterId: p.mieter_id, posten, summe: posten.reduce((s, x) => s + x.anzahl, 0),
    });
  }
  return m;
}
